import styled from "@emotion/styled";
import { HEADING, OLD_BLUE } from "src/constants/colors";
import { Agreement03 } from "src/assets/icons";

const TableEmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 250px;
  padding: 100px 20px;
`;

const TableEmptyStateHeading = styled.h2`
  font-weight: 600;
  font-size: 22px;
  leading-trim: Cap height;
  line-height: 100%;
  letter-spacing: -0.6%;
  text-align: center;
  margin-bottom: 20px;
  color: ${OLD_BLUE};
`;

const TableEmptyStateSubHeading = styled.p`
  font-weight: 400;
  font-size: 14px;
  leading-trim: Cap height;
  line-height: 100%;
  letter-spacing: -0.6%;
  text-align: center;
  color: ${HEADING};
  display: flex;
  gap: 2px;
`;

const TextBold = styled.span`
  font-weight: bold;
  display: flex;
  gap: 2px;
`;

export default () => (
  <TableEmptyStateContainer>
    <TableEmptyStateHeading>No Applications found.</TableEmptyStateHeading>
    <TableEmptyStateSubHeading>
      Try updating or removing filters or use the{" "}
      <TextBold>
        New application invite <Agreement03 fill={OLD_BLUE} />
      </TextBold>{" "}
      to start a new application.
    </TableEmptyStateSubHeading>
  </TableEmptyStateContainer>
);
